// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verifyWrap {
    position: relative;
  }
  .verifyWrap .block {
    position: absolute;
    left: 0;
    top: 0;
    cursor: pointer;
    cursor: grab;
  }
  .verifyWrap .block:active {
    cursor: grabbing;
  }
  .verifyWrap .sliderContainer {
    position: relative;
    text-align: center;
    width: 310px;
    height: 40px;
    line-height: 40px;
    margin-top: 15px;
    background: #f7f9fa;
    color: #45494c;
    border: 1px solid #e4e7eb;
  }
  .verifyWrap .sliderContainer_active .slider {
    height: 38px;
    top: -1px;
    border: 1px solid #486cd6;
  }
  .verifyWrap .sliderContainer_active .sliderMask {
    height: 38px;
    border-width: 1px;
  }
  .verifyWrap .sliderContainer_success .slider {
    height: 38px;
    top: -1px;
    border: 1px solid #0db87f;
    background-color: #0ca14a !important;
  }
  .verifyWrap .sliderContainer_success .sliderMask {
    height: 38px;
    border: 1px solid #0db87f;
    background-color: #d2f4ef;
  }
  .verifyWrap .sliderContainer_success .sliderIcon {
    background-position: 0 -26px !important;
  }
  .verifyWrap .sliderContainer_fail .slider {
    height: 38px;
    top: -1px;
    border: 1px solid #f57a7a;
    background-color: #f57a7a !important;
  }
  .verifyWrap .sliderContainer_fail .sliderMask {
    height: 38px;
    border: 1px solid #f57a7a;
    background-color: #fce1e1;
  }
  .verifyWrap .sliderContainer_fail .sliderIcon {
    top: 14px;
    background-position: 0 -82px !important;
  }
  .verifyWrap .sliderContainer_active .sliderText,
  .verifyWrap .sliderContainer_success .sliderText,
  .verifyWrap .sliderContainer_fail .sliderText {
    display: none;
  }
  .verifyWrap .sliderMask {
    position: absolute;
    left: 0;
    top: 0;
    height: 40px;
    border: 0 solid #486cd6;
    background: #d1e9fe;
  }
  .verifyWrap .slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    background: #fff;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    transition: background 0.2s linear;
    cursor: pointer;
    cursor: grab;
  }
  .verifyWrap .slider:active {
    cursor: grabbing;
  }
  .verifyWrap .slider:hover {
    background: #486cd6;
  }
  .verifyWrap .sliderIcon {
    font-size: 18px;
    color: #000;
  }
  .verifyWrap .slider:hover .sliderIcon {
    color: #fff;
  }
  .verifyWrap .refreshIcon {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    background-size: 32px;
  }
  .verifyWrap .loadingContainer {
    position: absolute;
    left: 0;
    top: 0;
    width: 310px;
    height: 155px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #45494c;
    z-index: 2;
    background: #edf0f2;
  }
  .verifyWrap .loadingIcon {
    width: 32px;
    height: 32px;
    margin-bottom: 10px;
    background: url(https://raw.githubusercontent.com/venkatmcajj/react-puzzle-captcha/master/docs/icon12.png);
    background-size: 32px;
    animation: loading-icon-rotate 0.8s linear infinite;
  }
  @keyframes loading-icon-rotate {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/PuzzleCaptcha.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,eAAe;IACf,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,SAAS;IACT,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,oCAAoC;EACtC;EACA;IACE,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,uCAAuC;EACzC;EACA;IACE,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,oCAAoC;EACtC;EACA;IACE,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,SAAS;IACT,uCAAuC;EACzC;EACA;;;IAGE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;IACtC,kCAAkC;IAClC,eAAe;IACf,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,0GAA0G;IAC1G,qBAAqB;IACrB,mDAAmD;EACrD;EACA;IACE;MACE,oBAAoB;IACtB;IACA;MACE,yBAAyB;IAC3B;EACF","sourcesContent":[".verifyWrap {\r\n    position: relative;\r\n  }\r\n  .verifyWrap .block {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    cursor: pointer;\r\n    cursor: grab;\r\n  }\r\n  .verifyWrap .block:active {\r\n    cursor: grabbing;\r\n  }\r\n  .verifyWrap .sliderContainer {\r\n    position: relative;\r\n    text-align: center;\r\n    width: 310px;\r\n    height: 40px;\r\n    line-height: 40px;\r\n    margin-top: 15px;\r\n    background: #f7f9fa;\r\n    color: #45494c;\r\n    border: 1px solid #e4e7eb;\r\n  }\r\n  .verifyWrap .sliderContainer_active .slider {\r\n    height: 38px;\r\n    top: -1px;\r\n    border: 1px solid #486cd6;\r\n  }\r\n  .verifyWrap .sliderContainer_active .sliderMask {\r\n    height: 38px;\r\n    border-width: 1px;\r\n  }\r\n  .verifyWrap .sliderContainer_success .slider {\r\n    height: 38px;\r\n    top: -1px;\r\n    border: 1px solid #0db87f;\r\n    background-color: #0ca14a !important;\r\n  }\r\n  .verifyWrap .sliderContainer_success .sliderMask {\r\n    height: 38px;\r\n    border: 1px solid #0db87f;\r\n    background-color: #d2f4ef;\r\n  }\r\n  .verifyWrap .sliderContainer_success .sliderIcon {\r\n    background-position: 0 -26px !important;\r\n  }\r\n  .verifyWrap .sliderContainer_fail .slider {\r\n    height: 38px;\r\n    top: -1px;\r\n    border: 1px solid #f57a7a;\r\n    background-color: #f57a7a !important;\r\n  }\r\n  .verifyWrap .sliderContainer_fail .sliderMask {\r\n    height: 38px;\r\n    border: 1px solid #f57a7a;\r\n    background-color: #fce1e1;\r\n  }\r\n  .verifyWrap .sliderContainer_fail .sliderIcon {\r\n    top: 14px;\r\n    background-position: 0 -82px !important;\r\n  }\r\n  .verifyWrap .sliderContainer_active .sliderText,\r\n  .verifyWrap .sliderContainer_success .sliderText,\r\n  .verifyWrap .sliderContainer_fail .sliderText {\r\n    display: none;\r\n  }\r\n  .verifyWrap .sliderMask {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 40px;\r\n    border: 0 solid #486cd6;\r\n    background: #d1e9fe;\r\n  }\r\n  .verifyWrap .slider {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 40px;\r\n    height: 40px;\r\n    background: #fff;\r\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);\r\n    transition: background 0.2s linear;\r\n    cursor: pointer;\r\n    cursor: grab;\r\n  }\r\n  .verifyWrap .slider:active {\r\n    cursor: grabbing;\r\n  }\r\n  .verifyWrap .slider:hover {\r\n    background: #486cd6;\r\n  }\r\n  .verifyWrap .sliderIcon {\r\n    font-size: 18px;\r\n    color: #000;\r\n  }\r\n  .verifyWrap .slider:hover .sliderIcon {\r\n    color: #fff;\r\n  }\r\n  .verifyWrap .refreshIcon {\r\n    position: absolute;\r\n    right: 5px;\r\n    top: 5px;\r\n    width: 30px;\r\n    height: 30px;\r\n    cursor: pointer;\r\n    background-size: 32px;\r\n  }\r\n  .verifyWrap .loadingContainer {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 310px;\r\n    height: 155px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    color: #45494c;\r\n    z-index: 2;\r\n    background: #edf0f2;\r\n  }\r\n  .verifyWrap .loadingIcon {\r\n    width: 32px;\r\n    height: 32px;\r\n    margin-bottom: 10px;\r\n    background: url(https://raw.githubusercontent.com/venkatmcajj/react-puzzle-captcha/master/docs/icon12.png);\r\n    background-size: 32px;\r\n    animation: loading-icon-rotate 0.8s linear infinite;\r\n  }\r\n  @keyframes loading-icon-rotate {\r\n    from {\r\n      transform: rotate(0);\r\n    }\r\n    to {\r\n      transform: rotate(360deg);\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
